export const Narrative = {
    interventions: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    medicalNecessity: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    responseToCareAndProgress: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    visitNarrative: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
};
